import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-phone-number-input/style.css';
import './assets/styles/index.css';
import './assets/styles/wide-screen.css';
import './assets/styles/tags.css';
import './assets/styles/buttons.css';
import './assets/styles/phoneInput.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { CartProvider } from "./context/CartContext";
import { ModalProvider } from "./context/ModalContext";
import { ProcessingProvider } from "./context/ProcessingContext";
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter basename="/">
    <ProcessingProvider>
      <CartProvider>
        <ModalProvider>
          <App />
        </ModalProvider>
      </CartProvider>
    </ProcessingProvider>
  </BrowserRouter>
);

reportWebVitals();
